import React from "react";

import AccordionDetails from "@material-ui/core/AccordionDetails";

import useStyles from "./styles";

interface IProps {
  children: React.ReactNode;
}

const FilterAccordionDetails = (props: IProps) => {
  const { children } = props;
  const classes = useStyles();

  return (
    <AccordionDetails
      classes={{
        root: classes.accordionDetails
      }}
    >
      {children}
    </AccordionDetails>
  );
};

export default FilterAccordionDetails;
